module.exports = __webpack_public_path__ + "img/ONLINE.28b8b23c.svg";